import React, { useEffect, useState, useRef } from "react";
import style from "./list.module.sass";
import { Icon, Spin, Table } from "antd";
import { ReactComponent as TableEdit } from '../../../../assets/svg/editIcon.svg'
import { ReactComponent as Delete } from '../../../../assets/svg/delete.svg'
import { useDispatch, useSelector } from "react-redux";
import { Http } from "../../../../helpers/axois";
import { ReactComponent as dmnIllustration } from '../../../../assets/svg/DMN_ico.svg'
import NoData from '../../NoData'
import { Button, Modal } from '../../../../helpers/commonUi'
import { ReactComponent as WarningIcon } from '../../../../assets/svg/warningIcon.svg'
import { AppState } from "../../../../stateManager/store";
import Dmn from "./Dmn";
import { useParams } from "react-router-dom";
import { useToast } from "../../../../helpers/commonFunction";
import { selectedDmn } from "../../../../stateManager/store/apps/actions";
import SearchBar, { highlightMatch } from "../../../../helpers/SearchBar";

interface Props {
    match?: any;
    app?: any;
    history?: any;
    selectedSolo?: any;
    selectedJourney?: any;
    deleteForm: (data: any) => void;
    appVersion?: { currentVersion: boolean, versionId: string };
    currentBranch?: any;
    pushToast: (data: any) => void;
    orgPermissions: any;
    appPermissions: any;
}

const DmnList = (props: Props) => {
    const { SuccessToast, ErrorToast } = useToast();
    const params: { appId?: string } = useParams()
    const appId: any = params.appId
    const [visible, setvisible] = useState(false)
    const [editInitialData, setEditInitialData] = useState({})
    const [editable, setEditable] = useState(false)
    const [editvisible, setEditVisible] = useState(false)
    const [dmnLoading, setDmnLoading] = useState(false)
    const [deleteVisible, setDeleteVisible] = useState(false)
    const [deleteData, setDeleteData]: any = useState({})
    const [dmnList, setDmnList] = useState([])
    const [filteredData, setFilterData] = useState<any[]>([])
    const searchRef = useRef<{ clearSearch: () => void }>(null);
    const [searchValue, setSearchValue] = useState<string>("")
    const dispatch = useDispatch()
    const currentBranch: any = useSelector((state: any) => {
        const selectedAppId = state.apps.selectedApp && state.apps.selectedApp.id
        return (state.apps.appBranch && state.apps.appBranch[selectedAppId]) || {}
    }, (left: any, right: any) => left.branchId === right.branchId)

    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const appPermissions: any = useSelector((state: any) => {
        return state.apps.selectedApp.permissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const orgId: any = useSelector((state: any) => {
        return state.org.selectedOrg.id
    })
    const appVersion = useSelector((state: AppState) => state.apps.appVersion && state.apps.appVersion[appId]);

    useEffect(() => {
        getDmn()
    }, [])

    const getDmn = () => {
        searchRef.current?.clearSearch()
        setDmnLoading(true)
        const versionId = appVersion && appVersion.versionId;
        if (versionId) {
            Http.get(`/apps/${appId}/dmn?versionId=${versionId}`).subscribe((formRes: any) => {
                setDmnList(formRes)
                setFilterData(formRes)
                setDmnLoading(false)
            }, (err: any) => {
                setFilterData([])
                setDmnLoading(false)
            });
        }
    }


    const deleteDmn = (dmnId: string) => {
        const appId = props.match.params.appId
        Http.delete(`/dmn/${dmnId}?appId=${appId}`).subscribe((res) => {
            SuccessToast('DMN deleted successfully', true)
            getDmn();
        }, (err) => {
            ErrorToast('DMN deletion failed', true)
        })
    }

    const currentVersion = appVersion && appVersion.currentVersion;
    const canEditdmn = currentVersion && (orgPermissions.includes('dmn.Edit') || appPermissions.includes('dmn.Edit'))
    const canCreatedmn = currentVersion && (orgPermissions.includes('dmn.Create') || appPermissions.includes('dmn.Create'))
    const canDeletedmn = currentVersion && (orgPermissions.includes('dmn.Delete') || appPermissions.includes('dmn.Delete'))
    const canViewdmn = orgPermissions.includes('dmn.View') || appPermissions.includes('dmn.View')

    const columns: any = [
        {
            title: "Name",
            dataIndex: "dmnName",
            key: "dmnName",
            render: (value: string)=>{
                const formattedValue = highlightMatch(value, searchValue)
                return formattedValue
            }
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            render: (value: string)=>{
                const formattedValue = highlightMatch(value, searchValue)
                return formattedValue
            }
        },
        {
            title: "Org Name",
            dataIndex: "orgName",
            key: "orgName",
            render: (value: string)=>{
                const formattedValue = highlightMatch(value, searchValue)
                return formattedValue
            }
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (value: string)=>{
                const formattedValue = highlightMatch(value, searchValue)
                return formattedValue
            }
        }
    ];

    if (currentVersion) {
        columns.push(
            {
                title: "Action",
                key: "action",
                render: (text: any, record: any) => (
                    <span>
                        <span data-test-id="action_edit"
                            className="action-icon edit-icon"
                            title="Edit"
                            onClick={e => {
                                e.stopPropagation();
                                if (canEditdmn) {
                                    setEditVisible(true)
                                    setEditInitialData(record)
                                    setEditable(true)
                                } else {
                                    ErrorToast('You are not authorized to edit this DMN', true)
                                }
                            }}
                        >
                            <TableEdit height='15px' width='15px' />
                        </span>
                        <span
                            data-test-id="action_delete"
                            className="action-icon delete-icon"
                            title="Delete"
                            onClick={e => {
                                e.stopPropagation();
                                if (canDeletedmn) {
                                    setDeleteData(record)
                                    setDeleteVisible(true)
                                } else {
                                    ErrorToast('You are not authorized to delete this DMN', true)
                                }
                            }}
                        >
                            <Delete style={{ width: "15px", height: "15px" }} />
                        </span>
                    </span>
                )
            }
        )
    }
    const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

    return (
        <>
            {canViewdmn ?
                <div className='viewWrapper'>
                    {
                        !dmnLoading ?
                            (
                                <React.Fragment>
                                    {
                                        (dmnList.length > 0) ?
                                            (
                                                <div className={"row " + style.data}>
                                                    <div className={style.header} >
                                                        <div className={style.first}>
                                                            <h4>DMN</h4>
                                                            <h5>View, edit or create DMN</h5>
                                                        </div>
                                                        <div className={"flex " + style.first}>
                                                            <SearchBar
                                                                ref={searchRef}
                                                                data={dmnList}
                                                                columns={columns}
                                                                onFilter={(filteredData ) => {
                                                                    setFilterData(filteredData)
                                                                }}
                                                                onSearchTermChange={ (searchValue: string)=>{ setSearchValue(searchValue) } }
                                                            />
                                                            {canCreatedmn &&
                                                                <Button dataTestId="create_dmn" size="small" onClick={() => { setvisible(true) }}>
                                                                    CREATE DMN
                                                                </Button>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className={style.content}>
                                                        <Table
                                                            pagination={false}
                                                            scroll={{ y: 'calc(100vh - 240px)' }}
                                                            columns={columns}
                                                            onRow={(record: any, rowIndex: any) => {
                                                                return {
                                                                    'data-test-id': 'dmn_table_row_' + record.key,
                                                                    onClick: () => {
                                                                        dispatch(selectedDmn(record))
                                                                        props.history.push(
                                                                            props.match.url +
                                                                            "/" +
                                                                            record.dmnId +
                                                                            "/create"
                                                                        );
                                                                    },
                                                                };
                                                            }}
                                                            data-test-id="dmn_table"
                                                            className={"override-table-container"}
                                                            dataSource={filteredData.map((res: any, key: any) => {
                                                                return { ...res, key: key };
                                                            })}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                            :
                                            (
                                                <NoData
                                                    svg={dmnIllustration}
                                                    header='Create DMN'
                                                    content='Create DMN diagram for your app'
                                                    buttonCallback={() => (canCreatedmn) ? (setvisible(true)) :
                                                        ErrorToast('You are not authorized to create DMN', true)
                                                    }
                                                />
                                            )
                                    }
                                </React.Fragment>
                            )
                            :
                            (
                                <div className={style.loadingSpinner}>
                                    <Spin indicator={antIcon} style={{ color: '#15808C' }} />
                                </div>
                            )
                    }
                    <FormModal
                        data-test-id="form_modal"
                        visible={visible}
                        getDmn={() => getDmn()}
                        appId={appId}
                        appVersion={props.appVersion}
                        setvisible={status => setvisible(status)}
                    ></FormModal>
                    {editvisible && (
                        <FormModal
                            data-test-id="edit_form_modal"
                            getDmn={() => getDmn()}
                            visible={editable}
                            editInitialData={editInitialData}
                            appId={appId}
                            appVersion={props.appVersion}
                            setvisible={status => {
                                setEditable(status)
                                setEditInitialData({})
                                setTimeout(() => {
                                    setEditVisible(false)
                                }, 400);
                            }}
                            editable={editable}
                        ></FormModal>
                    )}
                    {<Modal
                        dataTestId="delete_dmn"
                        id="deletedmn"
                        unmountOnCancel={true}
                        visible={deleteVisible}
                        title="DELETE DMN"
                        onCancel={() => {
                            setDeleteVisible(false)
                            setDeleteData({})
                        }}
                        deleteOptions={{
                            type: "dmn",
                            validateString: deleteData.dmnName
                        }}
                        footer={{
                            enable: true,
                            okText: 'DELETE',
                            cancelText: 'CANCEL',
                            onOk: () => {
                                deleteDmn(deleteData.dmnId)
                                setDeleteVisible(false)
                                setSearchValue("")
                                setFilterData(dmnList)
                            }
                        }}
                    />}
                </div>
                :
                <div className="viewWrapper">
                    <NoData
                        svg={WarningIcon}
                        header='Not Authorized'
                        content='Please request owner of this organization to provide access'
                        noButton={true}
                    />
                </div>}
        </>
    );
}

export default DmnList

interface FormmodelProps {
    appVersion?: { currentVersion: boolean, versionId: string };
    visible: boolean;
    getDmn?: () => void;
    getSolo?: () => void;
    setvisible: (status: boolean) => void;
    appId: any;
    editInitialData?: {};
    editSoloData?: {};
    editable?: boolean;
}
let onSubmit: any;
const FormModal = ({
    visible,
    getDmn,
    getSolo,
    setvisible,
    appId,
    appVersion,
    editInitialData,
    editSoloData,
    editable,
}: FormmodelProps) => {
    return (
        <Modal
            id="createEditdmn"
            dataTestId="created_edit_dmn"
            title={editInitialData ? 'EDIT DMN' : 'CREATE DMN'}
            visible={visible}
            onCancel={() => {
                setvisible(false);
            }}
            unmountOnCancel={true}
            footer={{
                enable: true,
                okText: editable ? "SAVE" : "CREATE",
                cancelText: "CANCEL",
                onOk: () => {
                    onSubmit();
                }
            }}
        >
            <Dmn
                appVersion={appVersion}
                setvisible={setvisible}
                appId={appId}
                getSolo={getSolo}
                getDmn={getDmn}
                editInitialData={editInitialData}
                editSoloData={editSoloData}
                onSubmit={(submit: any) => (onSubmit = submit)}
                editable={editable}
            ></Dmn>
        </Modal>
    );
};